import { Sheet, UserPlus } from 'lucide-react';
import { RecordContextProvider, useRecordContext, useTranslate } from 'ra-core';
import { DataTable } from '../../components/admin/data-table';
import { SelectField } from '../../components/admin/select-field';
import { TextField } from '../../components/admin/text-field';
import { ActionLink } from '../../components/custom/ActionLink';
import { RowActions } from '../../components/custom/RowActions';
import { MoonstarList } from '../Moonstar/MoonstarList';
import { KpiFormatIcon, KpiFormatName } from './KpiFormat';
import { KPI_FORMAT } from './types';

export const KpiList = () => {
  return (
    <MoonstarList sort={{ field: 'name', order: 'ASC' }}>
      <DataTable rowClick="edit" bulkActionButtons={false}>
        <DataTable.Col className="w-px whitespace-nowrap">
          <KpiFormatIconField />
        </DataTable.Col>
        <DataTable.Col source="name" />
        <DataTable.Col source="description">
          <TextField
            source="description"
            className="block max-w-[300px] truncate"
          />
        </DataTable.Col>
        <DataTable.Col source="format">
          <SelectField
            source="format"
            choices={[...KPI_FORMAT]}
            optionText={<KpiFormatName />}
          />
        </DataTable.Col>
        <DataTable.Col className="w-px whitespace-nowrap">
          <KpiActionButtons />
        </DataTable.Col>
      </DataTable>
    </MoonstarList>
  );
};

const KpiFormatIconField = () => {
  const record = useRecordContext();

  return (
    <RecordContextProvider value={{ id: record?.format }}>
      <KpiFormatIcon className="size-5" />
    </RecordContextProvider>
  );
};

const KpiActionButtons = () => {
  const record = useRecordContext();
  const translate = useTranslate();

  if (!record) {
    return null;
  }

  return (
    <RowActions>
      <ActionLink to={`/kpis/${record.id}/data`} icon={<Sheet />}>
        {translate('resources.kpis.fields.manageData')}
      </ActionLink>
      <ActionLink to={`/kpis/${record.id}/assignees/add`} icon={<UserPlus />}>
        {translate('resources.kpis.fields.addAssignees')}
      </ActionLink>
    </RowActions>
  );
};
